import { ReduxDispatch } from "models/ReduxProps";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import PracticeModel from "./models/PracticeModel";
import PracticeEffect, { IPracticeRequest } from "./PracticeEffects";

type ActionUnion = undefined | HttpErrorResponseModel | PracticeModel;

export default class PracticeAction {
    public static readonly REQUEST_PRACTICE: string = "PracticeAction.REQUEST_PRACTICE";
    public static readonly REQUEST_PRACTICE_FINISHED: string = "PracticeAction.REQUEST_PRACTICE_FINISHED";

    public static readonly PRACTICE_SET_AVVISO_POPUP: string = "SimulazioneAction.PRACTICE_SET_AVVISO_POPUP";

    public static practice(request: IPracticeRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<PracticeModel>(
                dispatch,
                PracticeAction.REQUEST_PRACTICE,
                PracticeEffect.practice,
                request
            );
        };
    }

    public static setAvvisoPopup(open: boolean): any {
        return ActionUtility.createAction(PracticeAction.PRACTICE_SET_AVVISO_POPUP, open);
    }
}
